import { render, staticRenderFns } from "./accommodations.vue?vue&type=template&id=3e2f3b9e&scoped=true&"
import script from "./accommodations.vue?vue&type=script&lang=js&"
export * from "./accommodations.vue?vue&type=script&lang=js&"
import style0 from "./accommodations.vue?vue&type=style&index=0&id=3e2f3b9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e2f3b9e",
  null
  
)

export default component.exports